import React from 'react';
import styled from '@emotion/styled';
import Colors from '../styles/Colors';
import Text, { TextTypesEnum } from './Text';
import Icon, { Icons } from './Icon';

type ContainerProps = {
  height?: string;
  margin?: string;
}

const Container = styled.div<ContainerProps>`
    display: flex;
    align-items: center;

    box-sizing: border-box;
    border: .5px solid ${Colors.Grey300};
    padding: 0 12px;
    border-radius: 4px;
    transition: all 0.1s;;
    height: ${(props) => props.height};
    margin: ${(props) => props.margin};

    &:hover {
      cursor: pointer;
      border: .5px solid ${Colors.Grey400};
    }

    &:active {
      border: 1px solid ${Colors.Black};
      background-color: ${Colors.Grey100};
    }
`;

type AccessButtonProps = {
  value: string;
  onClick?: Function;
  margin?: string;
  height?: string;
};

const AccessButton = React.forwardRef<HTMLDivElement, AccessButtonProps>(({
  value,
  onClick,
  margin,
  height = '32px',
}, ref) => (
  <Container ref={ref} onClick={() => onClick?.()} margin={margin} height={height}>
    <Icon icon={Icons.LockAltRegular} color={Colors.Grey600} size={10} margin="0 8px 0 0" />
    <Text type={TextTypesEnum.Medium12} color={Colors.Grey600} noWrap>{value}</Text>
    <Icon icon={Icons.AngleDownRegular} color={Colors.Grey600} size={10} margin="0 0 0 8px" />
  </Container>
));

export default AccessButton;
